export default __webpack_public_path__ + "static/media/grafico-1.86fca546.png";